import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;
export const Content = styled.main`
  width: 100%;
  height: 100%;
`;

export const ContentInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > p {
    font-size: 1.1rem;
    span {
      font-weight: 700;
      line-height: 1.3rem;
    }
  }
`;

export const DetalhesNegocioContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 1rem 2rem;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    display: block;
  }
`;

interface TituloGraficoProps {
  isBoletos?: boolean;
}

export const TituloGrafico = styled.h3<TituloGraficoProps>`
  font-size: 1.2rem;
  line-height: 1.4rem;
  margin-top: 1.3rem;
  margin-bottom: 1rem;
  color: var(--region-percentage);

  &:hover {
    cursor: ${(props) => props.isBoletos && 'pointer'};
    text-decoration: ${(props) => props.isBoletos && 'underline'};
  }
`;

export const QuantidadeParcelasContainer = styled.div`
  width: 500px;
  height: 100%;
  background: #fff;
  border-radius: 15px;
  margin: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    width: 100%;
    margin: auto;
  }
`;

export const GraficoInfoContainer = styled.div`
  padding: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const GraficosContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;

  @media (max-width: 1366px) {
    display: block;
  }
`;

export const GraficoBoletoContainer = styled.div`
  width: 100%;
  height: 20rem;
  background: #fff;
  border-radius: 15px;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1366px) {
    margin-bottom: 2rem;
  }
  @media (max-width: 416px) {
    overflow-x: scroll;
  }
`;

export const TipoNegocioContainer = styled.div`
  width: 100%;
  padding: 1rem;
  background: #fff;
  border-radius: 15px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const TipoNegocioData = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.5rem;

  @media (max-width: 768px) {
    max-width: calc(100vw - 7rem);
    overflow-x: scroll;
  }
`;

export const TipoNegocio = styled.div`
  margin: 3rem 0.5rem;
  padding: 1rem;

  background: var(--background);
  box-shadow: 1px 4px 4px 1px rgba(0, 0, 0, 0.2);
  border-radius: 5px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    font-size: 1rem;
    font-weight: 500;
    text-align: center;
    text-transform: uppercase;
  }

  h2 {
    margin-top: 1rem;
    font-size: 1.5rem;
    font-weight: 500;
    color: var(--percentage);
  }
`;
